import {
  trigger,
  transition,
  style,
  animate,
  state
} from '@angular/animations';
import { TransitionStates } from './transition.states';

const animateTiming = '1s {{delay}} cubic-bezier(.8,-0.6,0.2,1.5)';

export const fadeUpAndIn = trigger('fadeUpAndIn', [
  state('in', style({ opacity: 1, transform: 'translateY(0%)' })),
  state(
    'out',
    style({ opacity: 0, transform: 'translateY(10%)', display: 'none' })
  ),
  transition(TransitionStates.OUT + '=>' + TransitionStates.IN, [
    style({ display: 'block' }),
    animate(animateTiming)
  ]),
  transition(TransitionStates.IN + '=>' + TransitionStates.OUT, [
    animate(animateTiming)
  ]),
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(10%)' }),
    animate(animateTiming)
  ]),
  transition(':leave', animate(300, style({ opacity: 0 })))
]);
